import { memo, useContext } from 'react';

import { AdaptiveDpr, AdaptiveEvents } from '@react-three/drei';
import { Canvas, CanvasProps } from '@react-three/fiber';

import { DollhouseContext } from './DollhouseContext.js';

export interface DollhouseCanvasProps extends CanvasProps {
  debug?: boolean;
}

export const DollhouseCanvas: React.FC<DollhouseCanvasProps> = ({
  children,
  gl,
  performance,
  ...restProps
}) => {
  return (
    <Canvas
      frameloop="demand"
      gl={{
        powerPreference: 'high-performance',
        antialias: false,
        premultipliedAlpha: true,
        ...gl,
      }}
      performance={{
        min: 0.2,
        ...performance,
      }}
      {...restProps}
    >
      <AdaptiveDpr pixelated />
      <AdaptiveEvents />
      {children}
    </Canvas>
  );
};

export interface DollhouseProps extends Omit<DollhouseCanvasProps, 'store'> {}

export const Dollhouse: React.FC<DollhouseProps> = memo(({ children, ...restProps }) => {
  const store = useContext(DollhouseContext);

  return (
    <DollhouseCanvas store={store as any} {...restProps}>
      {children}
    </DollhouseCanvas>
  );
});

export default Dollhouse;
